export const SideNavs = {
    items: [
        {
            name: "لوحة التحكم",
            url: "/Maktapti/Dashboard",
            icon: "fa fa-tachometer",
            id:0
        },
        {
            id:0,
            name: "أعدادات التطبيق",
            icon: "fa fa-adn",
            children: [
                {
                    name: "عن التطبيق",
                    url: "/Maktapti/AboutApp"
                },
                {
                    name: "الشروط و الاحكام",
                    url: "/Maktapti/RulesConditions"
                },
                {
                    name: "سياسة الخصوصية",
                    url: "/Maktapti/Privacy"
                },
                {
                    name: "لينكات التواصل",
                    url: "/Maktapti/SocialLinks",
                    icon: "fa"
                },
                {
                    name: "البانر",
                    url: "/Maktapti/ViewBanners"
                },


                {
                    name: "تكلفة التوصيل",
                    url: "/Maktapti/DileveryCost"
                },
                {
                    name:  " تكلفة سلم واستلم",
                    url: "/Maktapti/HandedandRecieved"
                },
                

                {
                    name: "اسباب الرفض",
                    url: "/Maktapti/ViewReasons"
                }

            ]
        },
        {
            name: "الخدمات",
            url: "/Maktapti/Services",
            icon: "fa fa-archive",
            id:37
        },
        {
            name: "الصلاحيات",
            url: "/Maktapti/UserRules",
            icon: "fa fa-tag",
            id:38
        },
        {
            name: "المستخدمين",
            url: "/Maktapti/ViewClient",
            icon: "fa fa-user",
            id:39
        },
        {
            name: "المسؤلين",
            url: "/Maktapti/SubAdmins",
            icon: "fa fa-user-plus",
            id:40
        },
        {
            name: "المندوبين",
            url: "/Maktapti/Driver",
            icon: "fa fa-users",
            id:41
        },
       
        {
            name: "المتجر",
            url: "/Maktapti/Shop",
            icon: "fa fa-shopping-basket",
            id:42
        },
        {
            name: "المنتجات",
            url: "/Maktapti/ViewProducts",
            icon: "fa fa-product-hunt",
            id:43
        },
        {
            name: "الشهادات",
            url: "/Maktapti/Certifications",
            icon: "fa fa-certificate",
            id:44
        },

        {
            name: "الإشعارات",
            url: "/Maktapti/ViewNotification",
            icon: "fa fa-certificate",
            id:44
        },

        {
            id:45,
            name: "الطلبات",
            icon: "fa fa-tag",
            children: [
                {
                    name: "الطلبات المسعرة",
                    url: "/Maktapti/ViewPricing"
                },
                {
                    name: "الطلبات  غير مسعرة",
                    url: "/Maktapti/ViewNotPricing"
                },
            ]
        },
        {
            id:45,
            name: "الملازم",
            icon: "fa fa-tag",
            children: [
                {
                    name: "الملازم المسعرة",
                    url: "/Maktapti/ViewNotPricedMaterials"
                },
                {
                    name: "الملازم الغير مسعرة",
                    url: "/Maktapti/ViewMaterials"
                },
            ]
        },
        {
            name: "العروض",
            url: "/Maktapti/PromoView",
            icon: "fa fa-percent",
            id:46
        },


      
       
        
        {
            name: "التقارير",
            url: "/Maktapti/Reports",
            icon: "fa fa-file",
            id:47
        },


        // {
        //     name: "المراحل الدراسية",
        //     url: "/ViewLevels",
        //     icon: "fa"
        // },


    ],
};